<template>
  <div class="row pt-2">
    <div class="col"  v-if="modifierButton">
      <Button label="Modifier" v-on:click="modifier"/>
    </div>
    <div class="col">
      <Button label="Fermer" v-on:click="fermer"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "ButtonBarJournal",
  props: ['modifierButton'],
  emits: ['fermer', 'modifier'],
  methods: {
    modifier() {
      this.$emit('modifier');
    },
    fermer() {
      this.$emit('fermer');
    },
  }
}
</script>